import React, { useEffect, Suspense, lazy } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import { useWallet } from 'use-wallet'
import { ResetCSS } from '@pancakeswap-libs/uikit'
import BigNumber from 'bignumber.js'
import { useFetchProfile, useFetchPublicData } from 'state/hooks'
import GlobalStyle from './style/Global'
import Menu from './components/Menu'
import ToastListener from './components/ToastListener'
import PageLoader from './components/PageLoader'
import Pools from './views/Pools'

// Route-based code splitting
// Only pool is included in the main bundle because of it's the most visited page'
const Home = lazy(() => import('./views/Home'))
const Farms = lazy(() => import('./views/Farms'))
const Battlefield = lazy(() => import('./views/Battlefield'))
const NotFound = lazy(() => import('./views/NotFound'))
const NFT = lazy(() => import('./views/Nft'))
const Lottery = lazy(() => import('./views/Lottery'))
const Kingmaker = lazy(() => import('./views/Kingmaker'))
const MiniSatoshiCollectibles = lazy(() => import('./views/MiniSatoshiCollectibles'))
const GhostShibaCollectibles = lazy(() => import('./views/GhostShiba'))

// This config is required for number formating
BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

const App: React.FC = () => {
  const { account, connect } = useWallet()

  // Monkey patch warn() because of web3 flood
  // To be removed when web3 1.3.5 is released
  useEffect(() => {
    console.warn = () => null
  }, [])

  useEffect(() => {
    if (!account && window.localStorage.getItem('accountStatus')) {
      connect('injected')
    }
  }, [account, connect])

  useFetchPublicData()
  useFetchProfile()

  return (
    <Router>
      <ResetCSS />
      <GlobalStyle />
      <Menu>
        <Suspense fallback={<PageLoader />}>
          <Switch>
            <Route path="/" exact>
              <Home />
            </Route>
            <Route path="/lottery" exact>
              <Lottery />
            </Route>
            <Route path="/battlefield">
              <Battlefield />
            </Route>
            <Route path="/farms">
              <Farms />
            </Route>
            <Route path="/kingmaker">
              <Kingmaker />
            </Route>
            <Route path="/nft">
              <NFT />
            </Route>
            <Route path="/pools">
              <Pools />
            </Route>
            <Route path="/minisatoshicollectibles">
              <MiniSatoshiCollectibles />
            </Route>
            <Route path="/ghostshibacollectibles">
              <GhostShibaCollectibles />
            </Route>
            {/* Redirect */}
            {/* 404 */}
            <Route component={NotFound} />
          </Switch>
        </Suspense>
      </Menu>
      <ToastListener />
    </Router>
  )
}

export default React.memo(App)
